var expandedMenu = "#expandedMenu";
var expandedMenuMobile = "#expandedMenuMobile";
var expandedAssociationMenu = "#expandedAssociationMenu";
var expandedCalendar = "#expandedCalendar";
var expandedSearch = "#expandedSearch";
var associationLinkArrow = "#associationLinkArrow";
var activeClass = "active animate__animated animate__fadeIn animate__faster";

$('#menuLinkMobile').click(function (e) {
    e.preventDefault();

    if ($(expandedMenuMobile).hasClass("active")) {
        deactivateAll();
    }
    else {
        deactivateAll();
        menuLinkOpen("menuLinkMobile");
        $(expandedMenuMobile).addClass(activeClass);
        $("#overlay").addClass(activeClass);
    }

    return false;
});

$('#menuLink').click(function (e) {
    e.preventDefault();

    if ($(expandedMenu).hasClass("active")) {
        deactivateAll();
    }
    else {
        deactivateAll();
        menuLinkOpen("menuLink");
        $(expandedMenu).addClass(activeClass);
        $("#overlay").addClass(activeClass);
    }

    return false;
});

$("#associationLink").click(function (e) {
    e.preventDefault();

    if ($(expandedAssociationMenu).hasClass("active")) {
        deactivateAll();
    }
    else {
        deactivateAll();
        $(expandedAssociationMenu).addClass(activeClass);
        $(associationLinkArrow).addClass("active");
        $("#overlay").addClass(activeClass);
    }

    return false;
});

function searchLinkClicked(e) {
    e.preventDefault();

    if ($(expandedSearch).hasClass("active")) {
        deactivateAll();
    }
    else {
        deactivateAll();
        $(expandedSearch).addClass(activeClass);
        $("#overlay").addClass(activeClass);
        searchLinkOpen()
    }

    return false;
}

function calendarLinkClicked(e) {
    e.preventDefault();

    if ($(expandedCalendar).hasClass("active")) {
        deactivateAll();
    }
    else {
        deactivateAll();
        $(expandedCalendar).addClass(activeClass);
        $("#overlay").addClass(activeClass);
        $(e.currentTarget).addClass("active");
    }

    return false;
}

function deactivateAll() {
    $(expandedCalendar).removeClass(activeClass);
    $(expandedSearch).removeClass(activeClass);
    $(expandedMenu).removeClass(activeClass);
    $(expandedAssociationMenu).removeClass(activeClass);
    $(expandedMenuMobile).removeClass(activeClass);
    $(associationLinkArrow).removeClass("active");
    $("#overlay").removeClass(activeClass);
    menuLinkClosed("menuLink");
    menuLinkClosed("menuLinkMobile");
    searchLinkClosed();
    $("#calendarLink").removeClass("active");
    $("#calendarLinkMobile").removeClass("active");
}

$("#searchLinkMobile").click(function (e) {
    searchLinkClicked(e);
});

$("#searchLink").click(function (e) {
    searchLinkClicked(e);
});

$("#calendarLinkMobile").click(function (e) {
    calendarLinkClicked(e);
});

$("#calendarLink").click(function (e) {
    calendarLinkClicked(e);
});

function menuLinkOpen(id) {
    document.getElementById(id).innerHTML = "<div id='menuLinkImage' class='closed'>></div><p class='medium'><span>Lukk</span></p>";
}

function menuLinkClosed(id) {
    document.getElementById(id).innerHTML = "<div id='menuLinkImage' >></div><p class='medium'><span>Meny</span></p>";
}

function searchLinkOpen() {
    document.getElementById("searchLinkMobile").innerHTML = document.getElementById("searchLink").innerHTML = "<div class='mb-2 mb-md-0'>&#x2715; <span>Lukk søk</span></div>";
}

function searchLinkClosed() {
    document.getElementById("searchLinkMobile").innerHTML = document.getElementById("searchLink").innerHTML = "<div class='mb-2 mb-md-0'><span>Søk</span></div>";
}